<template>
  <div style="margin-left: 48px" class="d-flex my-2 mx-5">
    <div
      v-if="!dataDiligence"
      class="d-flex flex-column justify-center align-center w-100"
      style="margin-top: 50px"
    >
      <img src="../../assets/close-icon.png" alt="" class="mb-2" />
      <img src="../../assets/no-data-exercise.png" alt="" class="mb-5" />
      <span style="color: #828282"> Học sinh chưa có thông tin điểm </span>
    </div>
    <!--    <div v-if="!dataDiligence" style="margin: auto">-->
    <!--      <div style="text-align: center">-->
    <!--        <img src="/img/search-results.png" alt="" style="width: 20%" />-->
    <!--      </div>-->
    <!--      <div style="text-align: center">-->
    <!--        <span class="content-none">Chưa có dữ liệu chuyên cần</span>-->
    <!--      </div>-->
    <!--    </div>-->
    <div id="style-2" style="overflow: auto;width: 100%;">
      <table v-if="dataDiligence"  class="rate-table-new" style="width: 100%">
        <thead>
          <tr>
            <th style="width: 120px;">Tổng số buổi</th>
            <th>Tham gia</th>
            <th>Tỉ lệ tham gia</th>
            <th>Đi muộn</th>
            <th>Nghỉ phép</th>
            <th>Bảo lưu</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="min-width: 150px">
              {{ dataDiligence.totalLesson }}
            </td>
            <td>
              {{ dataDiligence.lessonJoin }}
            </td>
            <td>
              <div class="d-flex justify-center">
                <div class="my-auto">{{ dataDiligence.lessonJoinRatio }}%</div>
                <up-down-scope
                  v-if="dataDiligence.compareJoinRatio && ['increase','decrease'].includes(dataDiligence.compareJoinRatio) && dataDiligence.comparePointJoinRatio"
                  :percent="true"
                  :value="dataDiligence.comparePointJoinRatio"
                  :kind="dataDiligence.compareJoinRatio"
                ></up-down-scope>
              </div>
            </td>
            <td>
              {{ dataDiligence.lessonLate }}
            </td>
            <td style="min-width: 150px">
              {{ dataDiligence.onLeave }}
              <v-tooltip top v-if="dataDiligence.onLeaveDetail.length > 0">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="black" dark v-bind="attrs" v-on="on" dense>
                    mdi-information-outline
                  </v-icon>
                </template>
                <div>
                  <span
                    v-for="(onLeave, index) in dataDiligence.onLeaveDetail"
                    :key="onLeave.classCode + index"
                    class="text-no-wrap"
                  >
                    {{ index + 1 }}. Nghỉ phép ngày
                    {{ moment(onLeave.onLeaveDate).format("DD/MM/YYYY") }} - Mã
                    lớp: {{ onLeave.classCode }}
                    <br />
                  </span>
                </div>
              </v-tooltip>
            </td>
            <td>
              <div
                v-if="
                  dataDiligence.reservation && dataDiligence.reservation.length
                "
                class="d-flex m-auto justify-center"
              >
                <div class="px-3 py-2">
                  <div
                    v-for="(code, index) in dataDiligence.reservation"
                    :key="'code' + index"
                    class="d-flex mb-1"
                  >
                    <div v-if="checkShowDate(code.reservationDate, code.returnDate)">
                      <div class="content-reservation text-no-wrap">Đang bảo lưu lớp {{ code.classCode }}</div>
                      <div class="text-no-wrap" style="font-size: 12px">Từ {{ code.reservationDate ? moment(code.reservationDate).format("DD/MM/YYYY"): "-"}} - {{ code.returnDate ? moment(code.returnDate).format("DD/MM/YYYY") : "-" }}</div>
                    </div>
                    <div v-else class="text-center">--</div>
                  </div>
                </div>
              </div>
              <span v-else>--</span>
            </td>
          </tr>
        </tbody>
      </table>
      <note-filter-for-date
        v-if="dataDiligence"
        :dateTime="filterForm.dateTime"
      ></note-filter-for-date>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import NoteFilterForDate from '../ModalScoreDetail/NoteFilterForDate.vue';
import UpDownScope from '../ModalScoreDetail/UpDownScope.vue';

export default {
  components: { NoteFilterForDate, UpDownScope },
  name: 'AttendanceTab',
  data() {
    return {
      moment,
      loading: true,
    };
  },
  computed: {
    ...mapState('student_detail_bt', [
      'listDiligence',
      'activeFilterSubject',
      'filterForm',
    ]),
    dataDiligence() {
      return this.listDiligence.find(
        (item) => item.curriculumName === this.activeFilterSubject,
      );
    },
  },
  methods: {
    checkShowDate(reservationDate, returnDate) {
      const now = moment();
      const reservation = moment(reservationDate, 'YYYY-MM-DD');
      const returnDay = moment(returnDate, 'YYYY-MM-DD');
      return now.isBetween(reservation, returnDay);
    },
  },
};
</script>
<style lang="scss" scoped>
table {
  td {
    background: #F9F4F4;
    color: #000;
  }
}
.rate-table-new {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  th {
    padding: 8px;
    min-width: 120px;
    background: #4D4CAC;
    color: #fff
  }
  td {
    padding: 8px;
    text-align: center;
  }
}
</style>
<style scoped>
.content-reservation {
  color: #C62828;
  text-align: center;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px; /* 150% */
}
.gh-tutor {
  font-size: 10px;
  border-radius: 16px;
  margin-right: 12px;
  background: #cd91d7;
  padding: 8px 16px;
  color: white;
  width: fit-content;
  height: fit-content;
}
.content-none {
  color: #000;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Roboto;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 123.077% */
}
.td-table {
  background: #edd8fd;
  padding: 16px;
  min-width: 120px;
}
</style>
